@if (dataSource.length > 0) {
  <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
    @for (column of columns; track column.keyColumn) {
      <ng-container matColumnDef="{{ column.keyColumn }}">
        <th mat-header-cell *matHeaderCellDef>{{ column.description }}</th>
        <td mat-cell *matCellDef="let element">
          @if (column.keyColumn == 'action') {
            <div class="flex justify-end items-center gap-3">
              <!--              @if(element.statusId && element.statusId != 2 && element.statusId != 5){-->
              <!--              <mat-icon-->
              <!--                *ngIf="column.key.cancelContract && !spinLoad.cancelContract"-->
              <!--                class="btn-icon-outline"-->
              <!--                fontIcon="restore_page"-->
              <!--                matTooltip="Cancelar Contrato"-->
              <!--                (click)="cancelContractEvent(element)"-->
              <!--              />-->
              <!--              <mat-spinner-->
              <!--                *ngIf="column.key.cancelContract && spinLoad.cancelContract"-->
              <!--                diameter="24"-->
              <!--              ></mat-spinner>-->
              <!--              }-->

              @if (
                validStatus(element.statusId) &&
                column.key.replierItem &&
                !spinLoad.replierItem
              ) {
                <mat-icon
                  class="btn-icon-outline"
                  fontIcon="content_copy"
                  matTooltip="Replicar OS"
                  (click)="replierItemEvent(element)"
                />
              } @else if (
                validStatus(element.statusId) &&
                column.key.replierItem &&
                spinLoad.replierItem
              ) {
                <mat-spinner
                  diameter="24"
                  matTooltip="Replicando OS"
                ></mat-spinner>
              }

              <mat-icon
                *ngIf="column.key.sendContract && !spinLoad.contract"
                class="btn-icon-outline"
                fontIcon="newspaper"
                matTooltip="Gerar Contrato"
                [ngClass]="element.statusPropostaId != 4 ? 'disabled' : ''"
                (click)="sendContractEvent(element)"
              />
              <mat-spinner
                *ngIf="column.key.sendContract && spinLoad.contract"
                diameter="24"
                matTooltip="Gerando Contrato"
              ></mat-spinner>

              <mat-icon
                *ngIf="column.key.sendEmail && !spinLoad.email"
                class="btn-icon-outline"
                fontIcon="mail"
                matTooltip="Enviar email"
                [ngClass]="
                  element.statusPropostaId != 4 && element.statusPropostaId != 2
                    ? 'disabled'
                    : ''
                "
                (click)="sendEmailEvent(element)"
              />
              <mat-spinner
                *ngIf="column.key.sendEmail && spinLoad.email"
                diameter="24"
                matTooltip="Enviando email"
              ></mat-spinner>

              <mat-icon
                *ngIf="column.key.download && !spinLoad.download"
                class="btn-icon-outline"
                fontIcon="download"
                matTooltip="Baixar"
                (click)="downloadItemEvent(element)"
              />
              <mat-spinner
                *ngIf="column.key.download && spinLoad.download"
                diameter="24"
                matTooltip="Enviando email"
              ></mat-spinner>

              <mat-icon
                *ngIf="column.key.edit"
                class="btn-icon-outline"
                fontIcon="edit"
                matTooltip="Editar"
                (click)="selectItemEvent(element)"
              />

              <mat-icon
                *ngIf="column.key.manager"
                class="btn-icon-outline"
                fontIcon="settings"
                matTooltip="Gerenciar"
                (click)="managerItemEvent(element)"
              />

              <mat-icon
                *ngIf="column.key.view"
                class="btn-icon-outline"
                fontIcon="visibility"
                matTooltip="Visualizar"
                (click)="viewItemEvent(element)"
              />

              <mat-icon
                *ngIf="column.key.delete && !spinLoad.remove"
                class="btn-icon-outline"
                fontIcon="delete"
                matTooltip="Excluir"
                (click)="deleteItemEvent(element)"
              />
              <mat-spinner
                *ngIf="column.key.delete && spinLoad.remove"
                diameter="24"
              ></mat-spinner>
            </div>
          } @else if (column.keyColumn == 'phone') {
            {{ element[column.key] | telefone }}
          } @else if (column.keyColumn == 'cpf') {
            {{ element[column.key] | cpf }}
          } @else if (column.keyColumn == 'cnpj') {
            {{ element[column.key] | cnpj }}
          } @else if (column.keyColumn == 'os_event') {
            <b>TG: </b>{{ element.codigoTg || '-' }}<br />
            <b>Evento: </b>{{ element.nomeEvento || '-' }}
          } @else if (column.keyColumn == 'os_code') {
            <b>TG: </b>{{ element.codigoTg || '-' }}<br />
            <b>OS: </b>{{ element.codigoOs || '-' }}
          } @else if (column.keyColumn == 'os_client') {
            <b>Cliente: </b>{{ element.nomeCliente || '-' }}<br />
            <b>SubCliente: </b>{{ element.nomeSubCliente || '-' }}
          } @else if (column.keyColumn == 'os_consultant') {
            <b>Cliente: </b>{{ element.nomeConsultor || '-' }}<br />
            <b>Operacional: </b>{{ element.consultorComercial || '-' }}
          } @else if (column.keyColumn == 'os_period') {
            <b>Início: </b>{{ element.dataInicio || '-' }}
            {{ formatTime(element.horaInicio) || '-' }}<br />
            <b>Fim: </b>{{ element.dataFinal || '-' }}
            {{ formatTime(element.horaFinal) || '-' }}
          } @else if (column.keyColumn == 'os_period_new') {
            {{ element.dataInicio || '-' }} - {{ element.dataFinal || '-' }}
          } @else if (column.keyColumn == 'os_service') {
            <b>Tipo: </b>{{ element.tipoServico || '-' }}<br />
            <b>Serviço: </b>{{ element.servico || '-' }}
          } @else if (column.keyColumn == 'os_vehicle') {
            <b>Veículo: </b>{{ element.nomeTipoVeiculo || '-' }}<br />
            <b>Motorista: </b>{{ element.nomeTipoMotorista || '-' }}
          } @else {
            {{ element[column.key] }}
          }
        </td>
      </ng-container>
    }
    <tr
      mat-header-row
      class="style-header"
      *matHeaderRowDef="displayedColumns"
    ></tr>
    <tr
      mat-row
      class="style-row"
      *matRowDef="let row; columns: displayedColumns"
    ></tr>
  </table>
} @else {
  <div>
    <h3 class="text-center">Sem registros.</h3>
  </div>
}

<!--    <ng-container *ngFor="let column of columns;" matColumnDef="{{column.keyColumn}}">-->
<!--      <th mat-header-cell *matHeaderCellDef> {{ column.description }} </th>-->
<!--      <td mat-cell *matCellDef="let element">-->
<!--        @if (column.keyColumn == 'action') {-->
<!--          <button mat-flat-button class="btn-tg w-1/5" >-->
<!--            Editar-->
<!--          </button>-->
<!--        } @else {-->
<!--          {{element[column.key]}}-->
<!--        }-->
<!--      </td>-->
<!--    </ng-container>-->
